import React from "react";
import "./Help.css";
import { FaParking, FaBuilding, FaShuttleVan, FaSuitcase } from "react-icons/fa";

const HelpExtraFacilities = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Extra Facilities</h2>
          <p className="text-muted">
            Learn about parking, specific facilities, airport transfers, and luggage storage offered by properties on YOVHO.com.
          </p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaParking />
            </div>
            <div className="helpText">
              <h5>Parking</h5>
              <p>
                You can check if parking is available under the “Facilities” section on the property page before booking.
                If parking needs to be reserved in advance, contact the property directly using the phone number or email in your booking confirmation.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaBuilding />
            </div>
            <div className="helpText">
              <h5>Specific Facilities (e.g., elevator, kitchen)</h5>
              <p>
                Each property lists all available facilities, services, and activities on its page. If you need something specific — such as an elevator, kitchen, or wheelchair access — check the “Facilities” section before booking.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaShuttleVan />
            </div>
            <div className="helpText">
              <h5>Airport Shuttle or Pick-up Service</h5>
              <p>
                If a property offers airport pick-up or shuttle service, it will be mentioned under “Facilities.” After booking, contact the property directly to arrange your airport transfer. Share your flight details and arrival time for a smooth pickup.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaSuitcase />
            </div>
            <div className="helpText">
              <h5>Luggage Storage</h5>
              <p>
                Some properties provide luggage storage before check-in or after check-out. Availability will be shown under “Facilities.” Contact the property team using your booking confirmation to confirm timing and details.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HelpExtraFacilities;
